<aside
  class="sidebar-shell"
  [class.is-collapsed]="isCollapsed()"
  [attr.aria-label]="'layout.sidebar.ariaNavigation' | t"
>
  @if (!isCollapsed()) {
    <section class="workspace-block" [attr.aria-label]="'domain.company' | t">
      <app-company-switcher></app-company-switcher>
    </section>
  }

  <nav class="primary-nav" [attr.aria-label]="'layout.sidebar.ariaMainNavigation' | t">
    @for (item of primaryNavItems(); track item.route) {
      <app-sidebar-nav-item
        [label]="item.label"
        [icon]="item.icon"
        [route]="item.route"
        [isActive]="item.isActive"
        [badgeCount]="item.badgeCount || 0"
        [collapsed]="isCollapsed()"
      ></app-sidebar-nav-item>
    }
  </nav>

  <section class="context-nav" [attr.aria-label]="'layout.sidebar.ariaProjectTree' | t">
    @if (!isCollapsed()) {
      <div class="context-nav-header">
        <app-sidebar-section-title [title]="'layout.sidebar.treeTitle' | t"></app-sidebar-section-title>
        <button
          type="button"
          class="context-nav-add-btn"
          (click)="openCreateProjectModal()"
          [attr.aria-label]="'layout.sidebar.addProject' | t"
          [attr.title]="'layout.sidebar.addProject' | t"
        >
          <lucide-icon name="plus" class="h-4 w-4"></lucide-icon>
        </button>
      </div>

      <div class="tree-list">
        @if (sidebarLoading()) {
          <div class="tree-state">{{ 'layout.sidebar.loading' | t }}</div>
        } @else if (sidebarError()) {
          <div class="tree-state tree-state-error">
            <span>{{ sidebarError() }}</span>
            <button type="button" class="tree-state-action" (click)="retrySidebar()">
              {{ 'common.retry' | t }}
            </button>
          </div>
        } @else if (isSidebarEmpty()) {
          <div class="tree-state">{{ 'layout.sidebar.empty' | t }}</div>
        } @else {
          @for (project of projectTree(); track project.id) {
            <app-sidebar-project
              [project]="project"
              [expanded]="isProjectExpanded(project.id)"
              (toggleProject)="toggleProject($event)"
              (createWorkflow)="openCreateWorkflowModal($event)"
            ></app-sidebar-project>
          }
        }
      </div>
    } @else {
      <div class="tree-collapsed-list">
        @if (sidebarLoading()) {
          <span class="tree-collapsed-state" [attr.title]="'layout.sidebar.loading' | t">
            <lucide-icon name="loader-circle" class="h-4 w-4"></lucide-icon>
          </span>
        } @else if (sidebarError()) {
          <button
            type="button"
            class="tree-collapsed-state"
            (click)="retrySidebar()"
            [attr.title]="sidebarError() || ('common.retry' | t)"
          >
            <lucide-icon name="circle-alert" class="h-4 w-4"></lucide-icon>
          </button>
        } @else {
          @for (project of projectTree(); track project.id) {
            <a
              [routerLink]="[project.route]"
              class="rail-item tree-project-rail"
              [class.is-active]="project.isActive"
              [attr.aria-current]="project.isActive ? 'page' : null"
              [attr.aria-label]="project.name"
              [attr.title]="project.name"
            >
              @if (project.coverImageUrl) {
                <img [src]="project.coverImageUrl" [alt]="project.name" class="tree-project-cover" />
              } @else {
                <span class="tree-project-fallback">{{ project.initials }}</span>
              }
            </a>
          }
        }
      </div>
    }
  </section>

  @if (!isCollapsed()) {
    <section class="sidebar-onboarding-footer">
      <app-onboarding-checklist />
    </section>
  }

  <app-create-project-modal
    [visible]="isCreateProjectModalOpen()"
    (closed)="closeCreateProjectModal()"
    (created)="onProjectCreated($event)"
  ></app-create-project-modal>

  <app-create-workflow-from-project-modal
    [visible]="isCreateWorkflowModalOpen()"
    [projectId]="createWorkflowProjectId()"
    [projectName]="createWorkflowProjectName()"
    (closed)="closeCreateWorkflowModal()"
    (created)="onWorkflowCreated($event)"
  ></app-create-workflow-from-project-modal>
</aside>
